import { TrendsProvider, useTrends } from '../contexts/TrendsContext'
import EducationTrends from '../components/trends/EducationTrends'

function TrendsViewContent() {
  const { selectedCategory, trendsData, loading, error } = useTrends()

  return (
    <div className="space-y-6">
      {loading ? (
        <div className="text-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading trends data...</p>
        </div>
      ) : error ? (
        <div className="text-center py-12">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md mx-auto">
            <h3 className="text-red-800 font-medium mb-2">
              Error Loading Data
            </h3>
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        </div>
      ) : selectedCategory === 'education' ? (
        <EducationTrends trendsData={trendsData} />
      ) : (
        <div className="text-center py-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Health Trends
          </h2>
          <p className="text-gray-600">
            Health trend visualizations coming soon
          </p>
        </div>
      )}
    </div>
  )
}

function TrendsView() {
  return (
    <TrendsProvider>
      <TrendsViewContent />
    </TrendsProvider>
  )
}

export default TrendsView
